import { z } from "zod";

// All fields are optional till we get the required details from the backend
export const currencyCloudSchema = z.object({
  account_number: z.string().optional(),
  iban: z.string().optional(),
  bic_swift: z.string().optional(),
  sort_code: z.string().optional(),
  aba: z.string().optional(),
  bsb_code: z.string().optional(),
  bank_code: z.string().optional(),
  branch_code: z.string().optional(),
  clabe: z.string().optional(),
  cnaps: z.string().optional(),
  ifsc: z.string().optional(),
});

export type CurrencyCloudSchema = z.infer<typeof currencyCloudSchema>;
